const Backbone = require("backbone");
const APIConfig = require("apiconfig");

module.exports = Backbone.Model.extend({
  urlRoot: `${APIConfig.host}user/type`,
});
